<template>
  <v-container fluid class="pa-2">

    <!-- Plava traka s brojkama, kao na ostalim ekranima. -->
    <div class="traka">
      <h2 class="naslov">{{ lang.Tasks }}</h2>
      <div class="brojke">
        <div class="brojka" :class="{istice: brojCeka > 0}">
          <div class="v">{{ brojCeka }}</div>
          <div class="o">{{ lang.TasksWaitingMe }}</div>
        </div>
        <div class="brojka" :class="{istice: brojDospjelo > 0}">
          <div class="v">{{ brojDospjelo }}</div>
          <div class="o">{{ lang.TasksOverdue }}</div>
        </div>
        <div class="brojka">
          <div class="v">{{ brojPrikazano }}</div>
          <!-- "prikazano", ne "otvoreni": na jahacu "Zadao sam" i "Zavrseni" tu
               su i zatvoreni zadaci.
               "lang" je prazan do mounted hooka, pa se natpis ne smije obradivati
               u predlosku - prvi render bi pukao na undefined. -->
          <div class="o">{{ lang.TasksShown }}</div>
        </div>
      </div>
    </div>

    <v-card class="mt-0" tile>
      <!-- Jahaci: izvrsitelj i zadavatelj gledaju razlicite popise. Dosad je
           postojao samo "zadao sam", pa izvrsitelj svoj posao nije vidio. -->
      <v-tabs v-model="jahac" show-arrows height="42" @change="dohvati">
        <v-tab>
          {{ lang.TasksWaitingMe }}
          <v-chip v-if="brojCeka > 0" x-small class="ml-2" color="red" text-color="white">
            {{ brojCeka }}
          </v-chip>
        </v-tab>
        <v-tab>{{ lang.TasksIAssigned }}</v-tab>
        <v-tab>{{ lang.TasksAllOpen }}</v-tab>
        <v-tab>{{ lang.TasksDone }}</v-tab>
      </v-tabs>

      <v-divider></v-divider>

      <!-- Alati -->
      <div class="alati">
        <v-text-field
          v-model="trazi"
          :label="lang.TaskSearchDesc"
          dense
          hide-details
          clearable
          append-icon="mdi-magnify"
          class="alat-trazi"
          @keyup.enter="dohvati"
        ></v-text-field>

        <v-select
          v-model="vrsta"
          :items="vrste"
          :label="lang.taskTypeDescription"
          item-text="taskTypeDescription"
          item-value="taskTypeDescription"
          dense
          hide-details
          clearable
          class="alat-uzak"
        ></v-select>

        <v-text-field
          v-model="rokDo"
          :label="lang.TaskDueUntil"
          type="date"
          dense
          hide-details
          clearable
          class="alat-uzak"
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn small text color="primary" :loading="saving" @click="dohvati">
          <v-icon small left>mdi-refresh</v-icon>{{ lang.TaskSearch }}
        </v-btn>
        <v-btn small color="primary" @click="newtask">
          <v-icon small left>mdi-plus</v-icon>{{ lang.NewTask }}
        </v-btn>
      </div>

      <v-divider></v-divider>

      <app-task-list
        :items="prikazani"
        :saving="saving"
        :prazan-tekst="prazanTekst"
        @zatvoren="nakonZatvaranja"
      />
    </v-card>

    <!-- Sifrarnici stoje ispod popisa: koriste se rijetko, a prije su stajali
         iznad njega i uzimali prvi redak ekrana. -->
    <div class="mt-3">
      <appTaskChoose></appTaskChoose>
    </div>

    <v-row class="mt-1">
      <v-col cols="12">
        <TaskToDoList />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Tasklist from './TaskList'
import TaskChoose from './TaskChoose'
import TaskToDoList from './TaskToDoList'
import TaskService from '@/services/TaskService'
import TaskTypeService from '@/services/TaskTypeService'
import langEn from './taskDescEn'
import langHr from './taskDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import dayjs from 'dayjs'

const CEKAJU_ME = 0
const ZADAO_SAM = 1
const SVI_OTVORENI = 2
// Cetvrti jahac (zavrseni) je zadnja grana u "dohvati", pa nema svoju oznaku.

export default {
  name: 'taskindex',
  data () {
    return {
      lang: {},
      langC: {},
      jahac: CEKAJU_ME,
      svi: [],
      saving: false,
      trazi: '',
      vrsta: null,
      rokDo: null,
      vrste: []
    }
  },
  async mounted () {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    try {
      // Posluzitelj vraca kljuc "taskTypes" (veliko T).
      this.vrste = (await TaskTypeService.choose(this.osnovniUpit)).data.taskTypes
    } catch (err) {
      // Sifrarnik vrsta nije nuzan za popis - bez njega filtar samo ostane prazan.
      // eslint-disable-next-line
      console.log(err)
    }
    await this.dohvati()
  },
  computed: {
    osnovniUpit () {
      return {
        CompanyId: this.$store.state.companyid ? this.$store.state.companyid : 0,
        BusinessYear: this.$store.state.businessYear ? this.$store.state.businessYear : 0,
        CompanyNameDatabase: this.$store.state.companyName ? this.$store.state.companyName : '',
        UserId: this.$store.getters.NeedUserID
      }
    },
    brojCeka () {
      return this.$store.state.taskCekaBroj ? this.$store.state.taskCekaBroj : 0
    },
    brojDospjelo () {
      return this.prikazani.filter(t => !t.taskClosed && t.taskForDate &&
        dayjs(t.taskForDate).startOf('day').diff(dayjs().startOf('day'), 'day') <= 0).length
    },
    brojPrikazano () {
      return this.prikazani.length
    },
    // Trazenje i filtri rade nad vec dohvacenim popisom: zadataka je malo
    // (39 otvorenih u cijeloj bazi), pa nema razloga za vrtnju na posluzitelj.
    prikazani () {
      const t = (this.trazi ? this.trazi : '').toLowerCase().trim()
      return this.svi.filter(x => {
        if (t) {
          const uTekstu = ((x.taskShortDescription || '') + ' ' + (x.partnerName || '') + ' ' +
            (x.taskDetailDescription || '')).toLowerCase()
          if (uTekstu.indexOf(t) === -1) { return false }
        }
        if (this.vrsta && x.taskTypeDescription !== this.vrsta) { return false }
        if (this.rokDo && x.taskForDate && dayjs(x.taskForDate).isAfter(dayjs(this.rokDo), 'day')) { return false }
        return true
      })
    },
    prazanTekst () {
      if (this.svi.length > 0) { return this.lang.TasksNoneFound }
      return this.jahac === CEKAJU_ME ? this.lang.TasksNoneWaiting : this.lang.TasksNoneFound
    }
  },
  methods: {
    async dohvati () {
      try {
        this.saving = true
        const upit = {...this.osnovniUpit}

        if (this.jahac === CEKAJU_ME) {
          this.svi = (await TaskService.taskmoji({UserId: upit.UserId})).data.tasks
        } else if (this.jahac === ZADAO_SAM) {
          // "index" vraca zadatke koje je korisnik ZADAO.
          this.svi = (await TaskService.index(upit)).data.tasks
        } else if (this.jahac === SVI_OTVORENI) {
          const svi = (await TaskService.index(upit)).data.tasks
          const moji = (await TaskService.taskmoji({UserId: upit.UserId})).data.tasks
          // Isti zadatak moze biti i zadan i dodijeljen meni - spaja se po id-u.
          const po = new Map()
          svi.concat(moji).forEach(x => po.set(x.id, x))
          this.svi = [...po.values()].filter(x => !x.taskClosed)
        } else {
          this.svi = (await TaskService.taskmoji({UserId: upit.UserId, zatvoreni: 'true'})).data.tasks
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
        this.svi = []
      } finally {
        this.saving = false
      }
    },
    async nakonZatvaranja () {
      await this.dohvati()
      // Brojcic uz ikonu korisnika mora pasti odmah, ne tek za dvije minute.
      await this.osvjeziBrojcic()
    },
    async osvjeziBrojcic () {
      try {
        const {data} = await TaskService.taskceka({UserId: this.$store.getters.NeedUserID})
        this.$store.dispatch('setTaskCeka', data)
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async newtask () {
      await this.$store.dispatch('seteditItem', 0)
      await this.$router.push({name: 'taskcreate'})
    }
  },
  components: {
    appTaskList: Tasklist,
    appTaskChoose: TaskChoose,
    TaskToDoList
  }
}
</script>

<style scoped>
.traka {
  background: #0d47a1;
  color: #fff;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  border-radius: 4px 4px 0 0;
}
.naslov { font-size: 18px; font-weight: 500; margin: 0; }
.brojke { display: flex; gap: 20px; margin-left: auto; flex-wrap: wrap; }
.brojka { text-align: right; }
.brojka .v { font-size: 18px; font-weight: 700; line-height: 1.1; }
.brojka .o { font-size: 11px; opacity: .85; }
.brojka.istice .v { color: #ff8a80; }

.alati {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  padding: 8px 12px;
}
.alat-trazi { max-width: 230px; }
.alat-uzak { max-width: 160px; }

/* Korisnik radi na ~876 px: brojke tamo idu u svoj redak, inace se naslov i
   brojke stisnu jedno uz drugo. */
@media (max-width: 900px) {
  .brojke { width: 100%; margin-left: 0; justify-content: space-between; }
}
@media (max-width: 600px) {
  .alat-trazi, .alat-uzak { max-width: none; flex: 1 1 100%; }
}
</style>
